
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/compose/templates/layout"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='animated_regions'>\n  <div class='composeComponent-inputRegion'></div>\n  <div class='composeComponent-uploadRegion'></div>\n</div>\n";
},"useData":true});
    }).call(this);
  